<!--
 * @Author: lc
 * @Date: 2022-06-20 14:44:59
 * @LastEditors: lc
 * @LastEditTime: 2022-06-20 15:30:17
 * @Description: 
-->
<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          action="javascript:void(0)">
      <FormItem label="回收比例">
        <Input v-model="config.recovery_bili"
               placeholder="不可大于100%" />
      </FormItem>
      <FormItem label="设置运费">
        <RadioGroup v-model="config.fare_type"
                    @on-change="fareTypeStatus">
          <Radio label="0"
                 border>卖家承担运费</Radio>
          <Radio label="1"
                 border>自定义运费</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="运费计费方式"
                v-if="config.fare_type==1">
        <RadioGroup v-model="config.is_jijian"
                    @on-change="jijianStatus">
          <Radio label="1"
                 border>按件计费</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="指定条件包邮"
                v-if="config.fare_type==1">
        <Checkbox label="1"
                  v-model="config.jijian_rule_zhiding"></Checkbox>满
        <Input v-model="config.jijian_rule_zhiding_num"
               style="width:100px"></Input>件包邮
      </FormItem>
      <FormItem label="计价规则"
                v-if="config.fare_type==1">
        <Checkbox label="1"
                  v-model="config.jijian_rule"></Checkbox>默认运费
        <Input v-model="farerule.fare1"
               style="width:50px"></Input>件内
        <Input v-model="farerule.fare2"
               style="width:50px"></Input>元，每增加
        <Input v-model="farerule.fare3"
               style="width:50px"></Input>件，增加运费
        <Input v-model="farerule.fare4"
               style="width:50px"></Input>元
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>


<script>
export default {
  name: "config",
  data () {
    return {
      config: {
        fare_type: "0",
        is_jijian: "1",
        jijian_rule: false,
        jijian_rule_zhiding: false
      },
      farerule: {},
      showjijiantype: false,
      showjijianrule: false,
      showjijiannum: false,
    };
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    fareTypeStatus: function (val) {
      // 返回的是 lable值
      if (val == "0") {
        this.showjijiantype = false;
        this.showjijianrule = false;
      } else if (val == "1") {
        this.showjijiantype = true;
        this.showjijianrule = true;
      }
    },
    jijianStatus: function (val) {
      // 返回的是 lable值
      if (val == "0") {
        this.showjijiannum = false;
      } else if (val == "1") {
        this.showjijiannum = true;
      }
    },
    handleSubmit (name) {
      this.config.jijian_rule = this.config.jijian_rule ? "1" : "0";
      this.config.jijian_rule_zhiding = this.config
        .jijian_rule_zhiding
        ? "1"
        : "0";
      this.$api.mangheset.editfarerule({ config: this.config, farerule: this.farerule }).then(res => {
        if (res.code == 200) {
          this.$Message.success("修改成功...");
        }
      });
    },
    getConfig: function () {
      this.$api.mangheset.detail().then(res => {
        if (res.result) {
          this.config = res.result.config;
          this.config.fare_type = this.config.fare_type.toString();
          this.config.is_jijian = this.config.is_jijian.toString();
          this.config.jijian_rule =
            this.config.jijian_rule > 0 ? true : false;
          this.config.jijian_rule_zhiding =
            this.config.jijian_rule_zhiding > 0 ? true : false;
          //切换产品池邮费形式
          if (this.config.fare_type == "0") {
            this.showjijiantype = false;
            this.showjijianrule = false;
          } else if (this.config.fare_type == "1") {
            this.showjijiantype = true;
            this.showjijianrule = true;
          }
          //切换产品池计价形式
          if (this.config.is_jijian == "0") {
            this.showjijiannum = false;
          } else if (this.config.is_jijian == "1") {
            this.showjijiannum = true;
          }
          this.farerule = res.result.farerule;
        }
      });
    }
  }
};
</script>

